import { Emh5Host } from "emh5-hybrid";
import { Trade } from "emrn-hybrid/Trade";
import { pipeline } from "emrn-misc/pipeline";
import { Container } from "emrn-hybrid/Container";

import { cacheResult } from "__utils/cacheResult";

(function () {
  if (!Emh5Host.isEastmoneyApp) {
    Container.getEnv = function () {
      let env = "";
      env = "test"; // 测试线
      // env = "stage"; // 准上线
      // env = "prod"; // 正式线
      return Promise.resolve({ env });
    };

    Container.getDeviceInfo = function () {
      const os = Emh5Host.isios ? "ios" : "android";
      return Promise.resolve({
        osv: os,
        androidosv: os,
        model: Emh5Host.isios ? "iphone" : "pixel",
      });
    };

    Container.getApplicationInfo = function () {
      return Promise.resolve({
        appType: "cfw",
        appId: "eastmoney",
        appName: "东方财富",
        appVersionName: "10.5",
        appVersionCode: "10005000",
      });
    };

    // http://navigator1.18.cn/curcfg_new/05/testenv/ios/v10.4/trade_global_config_ios.txt
    Trade.getGlobalConfiguration = function () {
      let hshqsvr = "";
      let trade_gateway_http_url = "";

      hshqsvr = "http://10.10.190.103:8085";

      trade_gateway_http_url = "http://10.10.84.115:10002"; // 测试线-第2条线
      // trade_gateway_http_url = "http://10.10.84.79:10002"; // 测试线-第3条线
      // trade_gateway_http_url = "http://10.10.84.80:10002"; // 测试线-第4条线
      // trade_gateway_http_url = "https://alywgyz.eastmoney.com:11004"; // 准上线-万国机房
      // trade_gateway_http_url = "https://wgtradegateway.18.cn"; // 正式线-万国机房

      return Promise.resolve({
        content: JSON.stringify({
          trade_base_info: {
            trade_gateway_http_url,
            "rnquoteswitchurl-1": hshqsvr,
          },
        }),
      });
    };
  }

  Container.getPackageManifest = function () {
    const id = window["__emrnweb_appname"] || "";
    const version = window["__emrnweb_appversion"] || "";
    return Promise.resolve({
      mainfest: { id, version, title: document.title, md5: "", group: "" },
    });
  };

  Container.getApplicationInfo = cacheResult(
    pipeline(Container.getApplicationInfo)
  );
  Container.getPackageManifest = cacheResult(
    pipeline(Container.getPackageManifest)
  );
  Trade.getGlobalConfiguration = cacheResult(
    pipeline(Trade.getGlobalConfiguration)
  );
  Container.getDeviceInfo = cacheResult(pipeline(Container.getDeviceInfo));
})();
